import { connectionStore } from "../../../Common";
import { ConnectionNames } from "../../../Contracts";
import { SDQuerySubscribersStore } from "../SDQuerySubscribersStore";
import { sportsConnectionCloseHandler } from "../SportsConnectionCloseHandler";
import { connectWithSubscriptions } from "../ConnectWithSubscriptions";
function message(x) {
    return SDQuerySubscribersStore
        .getConnectionsForQuery(x.channel)
        .map(y => {
        y.onData(x.result);
        return y;
    });
}
function open(x) {
    // code available only in debug builds is excluded from coverage
    /* istanbul ignore next */
    if (process.env.NODE_ENV === "development") {
        console.warn("Opened socket:", x);
    }
}
function close(x) {
    let res = [false, -1];
    // code available only in debug builds is excluded from coverage
    /* istanbul ignore next */
    if (process.env.NODE_ENV === "development") {
        console.warn("Closed socket:", x);
    }
    const conn = connectionStore.get(ConnectionNames.sports);
    if (conn) {
        res = sportsConnectionCloseHandler(1000, connectWithSubscriptions.bind(undefined, conn), x);
    }
    return res;
}
export function sportsSocketConnectionHandlers(rqFormatter, rsFormatter) {
    return {
        open, close, message,
        requestFormatter: rqFormatter,
        responseFormatter: rsFormatter,
    };
}
//# sourceMappingURL=sportsSocketConnectionHandlers.js.map